// let authorization;
export var authorization = {
    headers: {
        authorization: localStorage.getItem("token"),
    },
};
export var userData = function () {
    var userString = localStorage.getItem("userData");
    if (userString) {
        var acc = JSON.parse(userString);
        return acc;
    }
    else {
        // toast.error("Bạn cần đăng nhập lại!");
        localStorage.clear();
        // setTimeout(()=>{
        //     window.location.reload();
        // }, 3000);
    }
};
